import React, { useMemo } from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';
import { RightOutlined } from '@ant-design/icons';
import { Collapse } from 'components/Transition';
import routeConfig from 'stores/menu';
import './style.scss';

const profileReg = /^\/profile\/?$/;

const Breadcrumb: React.FC = () => {
    const location = useLocation();
    const isRoot = profileReg.test(location.pathname);
    const subRoute = useMemo(() => {
        if (isRoot) {
            return null;
        }

        if (location.pathname.startsWith('/profile/bankcards')) {
            return null;
        }

        return routeConfig().find(route => matchPath(`/profile${route.path}`, location.pathname));
    }, [isRoot, location.pathname]);

    return (
        <Collapse in={!isRoot} timeout={200}>
            <div className="profile-bread">
                <Link to="/profile">{__('个人中心')}</Link>
                {subRoute && <RightOutlined />}
                {subRoute && (
                    <Link to={`/profile${subRoute.to}`} className="normal-color">
                        {subRoute.title}
                    </Link>
                )}
            </div>
        </Collapse>
    );
};

export default Breadcrumb;
